import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M3.999 11c-1.111 0-2.667-.5-2.667-2.5 0-2.333 2.333-2.833 3-2.833.333-1.167 1-3 3.667-3 2.333 0 3.333 1.333 3.666 2.5 0 0 3 .333 3 3.167 0 2-1.333 2.666-2.666 2.666"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m6 11 2 1.667 2.667-3.334"
    }, null, -1)
  ])))
}
export default { render: render }